import { useRef, useEffect } from "react";

function useAutoFocus() {
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);
  return inputRef;
}

export default useAutoFocus;
